import React, { useEffect } from "react";

// Public privacy policy for the Craft Cabinet app ("/craft-cabinet").
// Standalone top-level route: no authentication, no API calls, no sidebar.
export default function CraftCabinetPrivacy() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Privacy Policy — Craft Cabinet";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="bg-white" style={{ minHeight: "100vh", padding: "3rem 1.5rem" }}>
      <main className="mx-auto" style={{ maxWidth: "42rem" }}>
        <h1 className="mb-1">Privacy Policy — Craft Cabinet</h1>
        <p className="text-muted mb-4">Last updated: August 2026</p>

        <p>
          Craft Cabinet does not collect, transmit, or share any personal
          information. All data you enter — cabinets, drawers, items, photos,
          descriptions, and notes — is stored only on your device. We do not use
          analytics, advertising, or tracking of any kind, and we have no access
          to your data.
        </p>

        <p>
          <strong>Photos:</strong> If you choose to add a photo to an item, the
          app uses your camera and/or photo library solely to attach that image
          within the app. Your photos remain on your device.
        </p>

        <p>The app requires no account and no internet connection.</p>

        <p className="mb-0">
          Contact:{" "}
          <a href="mailto:jschell@incubate.pro">jschell@incubate.pro</a>
        </p>
      </main>
    </div>
  );
}
